import React from "react";

interface IFootnote {
  id: number;
}

const Footnote: React.FC<IFootnote> = ({ id = 1 }): JSX.Element => (
  // <Link
  //   href={`#footnote-${id}`}
  //   onClick={(e) => e.stopPropagation()}
  //   sx={{ textDecoration: "none", fontWeight: "bold" }}
  // >
  // </Link>
  <>
    &nbsp;
    <sup>{id}</sup>
  </>
);

export default Footnote;
